import RatingBindings from './RatingBindings.js';

export default class Rating {
    constructor($selector, settings) {

        this.field = 'js-rate-field';

        this.$selector = $selector;
        this.settings = settings;

        new RatingBindings(this);

    }
}


// WEBPACK FOOTER //
// ./src/common/modules/star-rating-static/Rating.js